const decimalFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 8,
})

const shortFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
})

const percentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const percentSignFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  signDisplay: 'always',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// const priceFormatter = new Intl.NumberFormat('en-US', {
//   style: 'currency',
//   currency: 'USD',
//   currencyDisplay: 'narrowSymbol',
// })

export const formatDecimal = decimalFormatter.format

export function formatValue(value: number, showDollarSign: boolean = true) {
  if (showDollarSign) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value)
  } else {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  }
}

export function formatTotal(value: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value)
}

export const formatToPrecision = (
  value: number | bigint,
  precision: number = 2
) =>
  new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(value)

export const formatNumberToParts = (
  value: number | bigint,
  precision: number = 2
): [string, string] => {
  let priceInteger = ''
  let priceFraction = ''

  const parts = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).formatToParts(value)

  parts.forEach((part) => {
    if (part.type === 'decimal' || part.type === 'fraction') {
      priceFraction += part.value
    } else {
      priceInteger += part.value
    }
  })

  return [priceInteger, priceFraction]
}

export const formatShort = shortFormatter.format

export const formatPercent = (value: number | bigint, displaySign?: boolean) =>
  displaySign
    ? percentSignFormatter.format(value)
    : percentFormatter.format(value)

export function nFormatter(num: number) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/
  const item = lookup.findLast((item) => num >= item.value)
  return item
    ? (num / item.value).toFixed(2).replace(regexp, '').concat(item.symbol)
    : '0'
}
